import { formatPriceShort } from '@helpers/utils'

const normalizeWhitespace = (value: string): string => value.replace(/\s/g, ' ').trim()

export const formatClientOptionSaleTitle = (kindDisplay: string, priceBrutto: number | string): string => {
  const price = formatPriceShort(priceBrutto)

  return normalizeWhitespace(kindDisplay).endsWith(normalizeWhitespace(price)) ? kindDisplay : `${kindDisplay} ${price}`
}
